import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Row, Skeleton, Table, Tooltip } from "antd";
import React from "react";
import AddTermsAndCondition from "./AddTermsAndCondition";
import TermsAndConditionsService from "../../Services/TermsAndConditionsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { Voucher_Type } from "../../Services/VoucherServices";
import { ColumnsType } from "antd/es/table";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { useTheme } from "../../Context/ThemeContext";
import { voucherType } from "../Reports/VoucherDetailsByLedger";
import Search from "antd/es/transfer/search";

export interface ITermsAndConditions {
  SNo: number;
  id: string;
  templateName: string;
  termNConditions: string;
  voucherType: Voucher_Type;
  voucherTitle: string;
}

const TermsAndConditions = () => {
  const { currentClient } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = React.useContext(notificationContext);
  const [conditionList, setConditionList] = React.useState<
    ITermsAndConditions[]
  >([]);
  const [id, setId] = React.useState<any>();
  const [confirmation, setConfirmation] = React.useState<{
    open: boolean;
    name: string;
  }>({ open: false, name: "" });
  const [pageSize, setPageSize] = React.useState<number>(15);
  const [page, setPage] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);
  const [search, setSearch] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [voucher, setVoucher] = React.useState<Voucher_Type>();
  const [voucherTitle, setVoucherTitle] = React.useState<string>();
  const [refresh, setRefresh] = React.useState<Boolean>();
  React.useEffect(() => {
    getTnC();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(page - 1) * pageSize, pageSize, search, refresh]);

  const getTnC = async () => {
    setLoading(true);
    try {
      let res = await TermsAndConditionsService?.getTermsAndConditionList(
        currentClient?.id,
        Voucher_Type?.All,
        (page - 1) * pageSize,
        pageSize,
        search
      );
      if (res?.result) {
        setConditionList(
          res?.result?.map((d: any, index: number) => {
            return {
              SNo: index + 1,
              id: d?.id,
              templateName: d?.templateName,
              termNConditions: d?.termNConditions,
              voucherType: d?.voucherType,
              voucherTitle: d?.voucherTitle,
            };
          })
        );
      } else {
        console.error(res?.message);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const deleteDatabyId = async () => {
    let res = await TermsAndConditionsService?.deleteDatabyId(
      currentClient?.id,
      id
    );
    if (res?.status) {
      openNotification("success", "Deleted successfully.");
      getTnC();
      setConfirmation({ open: false, name: "" });
    } else {
      openNotification("error", res?.message);
      setConfirmation({ open: false, name: "" });
    }
  };

  const columns: ColumnsType<ITermsAndConditions> = [
    {
      title: "S.No.",
      dataIndex: "SNo",
      key: "SNo",
      width: "5%",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.SNo}
        </Skeleton>
      ),
    },
    {
      title: "Template Name",
      dataIndex: "templateName",
      width: "20%",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.templateName}
        </Skeleton>
      ),
    },
    {
      title: "Terms and Conditions",
      dataIndex: "termNConditions",
      // width: "20%",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: record.termNConditions,
            }}
          />
        </Skeleton>
      ),
    },
    {
      title: "Voucher Title",
      dataIndex: "voucherTitle",
      width: "12%",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherTitle}
        </Skeleton>
      ),
    },
    {
      title: "Voucher Type",
      dataIndex: "voucherType",
      width: "12%",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {voucherType[record?.voucherType]}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      width: "7%",
      render: (record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <Row gutter={10}>
            <Col>
              <Tooltip title="Edit">
                <FormOutlined
                  onClick={() => {
                    setId(record?.id);
                    setVoucher(record?.voucherType);
                    setVoucherTitle(record?.voucherTitle);
                    setIsModelOpen(true);
                  }}
                />
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Delete" color="red">
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    setId(record?.id);
                    setConfirmation({ open: true, name: "" });

                    // setConfirmation({ open: true, name: record?.templateName });
                  }}
                />
              </Tooltip>
            </Col>
          </Row>
        </Skeleton>
      ),
    },
  ];

  return (
    <>
      <div>
        <Row justify={"space-between"}>
          <Col>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              onClick={() => {
                setIsModelOpen(true);
                setId("");
              }}
            >
              Add Terms & Conditions
            </Button>
          </Col>
          <Col>
            <Search
              placeholder="Search..."
              onChange={(e: any) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        <Table
          rowKey="SNo"
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          columns={columns}
          dataSource={conditionList}
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
            pageSizeOptions: ["10", "15", "25", "50", "100"],
          }}
          scroll={
            pageSize > 15 ? { x: 1500, y: window.innerHeight - 300 } : undefined
          }
        />
      </div>
      {isModelOpen && (
        <AddTermsAndCondition
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
          id={id}
          voucher={voucher}
          setRefresh={setRefresh}
          voucherTitle={voucherTitle}
        />
      )}
      {confirmation.open && (
        <ConfirmationModal
          open={confirmation.open}
          onNo={() => setConfirmation({ open: false, name: "" })}
          onYes={() => {
            deleteDatabyId();
          }}
          text={`Are you sure you want to delete this ${
            confirmation.name ? ` "${confirmation.open}"` : ""
          } Terms & Conditions ? `}
        />
      )}
    </>
  );
};

export default TermsAndConditions;
